import { FunctionComponent } from 'react';
import Program from 'wwg-utilities/dist/collections/program';
import costMeritsIconMapping from '../../../lib/config/project/costMeritsIconMapping';
import CircleIcon from '../../icons/Circle';

interface CostMeritsProps {
    program: Program;
}

const CostMerits: FunctionComponent<CostMeritsProps> = ({
    program,
}) => {
    let costMerits = program.costMerits;
    // TODO add icon mappings
    if (!costMerits) {
        return <></>;
    }

    return (
        <>
            <div className="flex flex-wrap my-4">
                {costMerits.map((merit: string) => {
                    return (
                        <div key={merit} className="flex items-center m-2">
                            <CircleIcon
                                icon={(costMeritsIconMapping as any)[merit]}
                                className="p-2 bg-requirements"
                            />
                            <p className="text-xs md:text-sm xl:text-base">
                                &nbsp;&nbsp;&nbsp;{merit}
                            </p>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default CostMerits;
